import { Injectable } from '@angular/core';
import { AuthService } from 'app/modules/authentication/services/auth.service';
import { User } from 'app/modules/shared/model/user';
import { ApiProxyService } from 'app/modules/shared/services/api-proxy.service';
import { Observable, Subscription, of } from 'rxjs';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  currentUser: User;
  userSubscription: Subscription;

  constructor(private apiProxy: ApiProxyService,
    private authService: AuthService,
    private configService: ConfigService) { }

  public getUsers(): Observable<User[]> {
    return this.apiProxy.get<User[]>(this.configService.apiUrl + 'users');
  }

  public deleteUser(user: User) {
    return this.apiProxy.delete<User>(`${this.configService.apiUrl}users/${user.userName}`);
  }

  public updateUser(user: User) {
    return this.apiProxy.put<User>(this.configService.apiUrl + 'users', user);
  }

  public getUser(username: string) {
    return this.apiProxy.get<User>(this.configService.apiUrl + 'users/' + username);
  }

  public userIsAdmin(username: string) {
    return this.apiProxy.get(this.configService.apiUrl + 'users/isAdmin' + username);
  }

  public getCurrentUser(): Observable<User> {
    return this.authService.user;
  }
}
